import React from 'react'
import { IonIcon } from '@ionic/react'
import { checkmark } from 'ionicons/icons'
import { getStyleForPHI, IPHIComponent } from '../phi/phi.component'
import './Stepper.component.css'
import skippedIcon from '../../features/ekgImport/data/SkippedIcon.svg'
export interface IStep {
  id: number
  title: string
  isCompleted?: boolean
  isSkipped?: boolean
  customIcon?: string
  skipCondition?: () => boolean
}

export interface IStepperProps extends IPHIComponent {
  steps: IStep[]
  currentStep: number
  title?: string
  className?: string
  onStepClick?: (stepId: number) => void
}

const getStepState = (step: IStep, currentStep: number) => {
  if (currentStep > step.id) {
    const shouldSkip = step.skipCondition ? step.skipCondition() : step.isSkipped
    return shouldSkip ? 'skipped' : 'completed'
  }
  return currentStep === step.id ? 'active' : 'inactive'
}

const getStepIcon = (step: IStep, state: string) => {
  if (state === 'skipped') {
    return <img src={skippedIcon} alt='' />
  }

  if (state === 'completed') {
    return <IonIcon className='stepper-checkmark' color='white' icon={checkmark} />
  }

  if (state === 'inactive') {
    return <div className='stepper-vertex-circle-inner' />
  }

  return null
}

const renderVertex = (step: IStep, currentStep: number, onStepClick?: (stepId: number) => void, isPHI = false) => {
  const state = getStepState(step, currentStep)
  const isClickable = onStepClick && currentStep >= step.id

  return (
    <div
      className={`stepper-vertex ${isClickable ? 'clickable' : ''}`}
      onClick={() => isClickable && onStepClick?.(step.id)}>
      <div className={`stepper-vertex-label ${state}`}>{step.title}</div>
      <div className={`stepper-vertex-circle ${state}`}>{getStepIcon(step, state)}</div>
    </div>
  )
}

const renderSegment = (step: IStep, currentStep: number) => {
  const isActive = step.id < currentStep

  return (
    <div className='stepper-segment-wrapper'>
      <div className={`stepper-segment ${isActive ? 'active' : ''}`} />
    </div>
  )
}

const Stepper = (props: IStepperProps) => {
  const { steps, currentStep, title, className = '', onStepClick, isPHI = false } = props

  return (
    <div className={`stepper-container ${className}`}>
      {title && (
        <div className='stepper-title' style={getStyleForPHI(isPHI)}>
          {title}
        </div>
      )}
      <div className='stepper'>
        {steps.map((step, index) => (
          <React.Fragment key={step.id}>
            {renderVertex(step, currentStep, onStepClick, isPHI)}
            {index < steps.length - 1 && renderSegment(step, currentStep)}
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

export default Stepper
